export default "__VITE_ASSET___MTMlCi7__"